module.exports = __webpack_public_path__ + "img/become-partner-banner.f1c036c9.jpg";